import React from 'react';
// @ts-ignore
import styles from './PlanTimeline.module.scss';
import PlanTimelineItem from './PlanTimelineItem';
import useTranslation from '../../../Hooks/useTranslation';
import { HealthPlanTimelineGroup } from '../../../Models/HealthPlan/HealthPlanTimelineGroup';
import useHealthPlan from '../../../Modules/HealthPlan/Hooks/useHealthPlan';

interface PlanTimelineColumnProps {
	data: HealthPlanTimelineGroup;
	healthPlanUser: any;
	reloadData: any;
	workplaceId: string;
	patientId: string;
	allowEdit: boolean;
	onTitleClick: (item: HealthPlanTimelineGroup) => void;
}

const PlanTimelineColumn: React.FC<PlanTimelineColumnProps> = ({
	data,
	healthPlanUser,
	workplaceId,
	reloadData,
	patientId,
	allowEdit,
	onTitleClick,
}) => {
	const { t } = useTranslation();

	const { isBaby } = useHealthPlan();

	const lineStyle = {
		height: 'calc(100% - 35px)',
	};

	if (isBaby) {
		lineStyle['height'] = 'calc(100% - 65px)';
	}

	return (
		<div className={styles.column} key={data.month}>
			{data.children.map((item: any) => (
				<React.Fragment key={`child${item.id}`}>
					<PlanTimelineItem
						allowEdit={allowEdit}
						item={item}
						patientId={patientId}
						workplaceId={workplaceId}
						reloadData={reloadData}
					/>
				</React.Fragment>
			))}
			<div className={styles.title} onClick={() => onTitleClick(data)}>
				{data.month <= 10 || !isBaby
					? data.shortTitle
					: `${data.shortTitle.split(' ')[0]} ${data.month - 10}`}
			</div>
			{isBaby && <div className={styles.subtitle}>{data.subTitle}</div>}
			{healthPlanUser.activeMonth
				? healthPlanUser.activeMonth === data.month && (
						<>
							<div style={lineStyle} className={styles.line} />
							<div className={styles.lineBadge}>{t('base.shared.now')}</div>
						</>
				  )
				: data.month === 1 && (
						<>
							<div style={lineStyle} className={styles.line} />
							<div className={styles.lineBadge}>{t('base.shared.now')}</div>
						</>
				  )}
		</div>
	);
};

export default PlanTimelineColumn;
